module.exports = __webpack_public_path__ + "img/bazarImage.40ec67d8.svg";